<template>
  <div class="">
    
    <PageHeader label="Uploading to Mercury"></PageHeader>

    <div class="mt-8">
      Uploading...
    </div>
  </div>
</template>

<script>

  import axios         from "axios"
  import { EventBus }  from '@/shared/event-bus';
  import PageHeader    from '@/shared/components/headers/PageHeader'

  export default {

    components : {
      PageHeader,
    },

    data () {
      return {
        client  : null,
      }
    },

    created() {
      this.apiPost({
        clientId : this.$route.params.clientId
      }, 'mercury/upload', () => {
        
      })
    }
  }
</script>